import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxChartModule } from 'devextreme-angular';
import { NgZorroAntDModule } from './antd.module';
import { AlertMessageComponent } from './components/alert-message/alert-message.component';
import { CreateEstimationDrawerComponent } from './components/create-estimation-drawer/create-estimation-drawer.component';
import { CreateProviderModalComponent } from './components/create-provider-modal/create-provider-modal.component';
import { DashboardEstimationTableComponent } from './components/dashboard-estimation-table/dashboard-estimation-table.component';
import { DashboardRequisitionTableComponent } from './components/dashboard-requisition-table/dashboard-requisition-table.component';
import { EstimationPieChartComponent } from './components/estimation-pie-chart/estimation-pie-chart.component';
import { ClickOutsideDirective } from "./directives/click-outside.directive";
import { EstimationTableComponent } from './components/estimation-table/estimation-table.component';
import { InfoDashboardCardComponent } from "./components/info-dashboard-card/info-dashboard-card.component";
import { LoadPanelComponent } from './components/load-panel/load-panel.component';
import { LotsTagBoxComponent } from './components/lots-tag-box/lots-tag-box.component';
import { PriorityTagComponent } from './components/priority-tag/priority-tag.component';
import { ProjectsSearchComponent } from './components/projects-search/projects-search.component';
import { RequisitionPieChartComponent } from './components/requisition-pie-chart/requisition-pie-chart.component';
import { RequisitionTableComponent } from './components/requisition-table/requisition-table.component';
import { ResourcesTagBoxComponent } from './components/resources-tag-box/resources-tag-box.component';
import { SearchProviderModalComponent } from './components/search-provider-modal/search-provider-modal.component';
import { StatusTagComponent } from './components/status-tag/status-tag.component';
import { StructureTreelistComponent } from './components/structure-treelist/structure-treelist.component';
import { DevExtremeModule } from './devextreme.module';
import { ShortCurrencyPipe } from './pipes/currency-format.pipe';
import { HighlighterPipe } from './pipes/highlighter.pipe';
import { ResourcesTreeSelectorComponent } from './components/resources-tree-selector/resources-tree-selector.component';

@NgModule({
  imports: [
    CommonModule,
    NgZorroAntDModule,
    DevExtremeModule,
    FormsModule,
    DxChartModule,
    ClickOutsideDirective,
    ReactiveFormsModule
  ],
  declarations: [
    ShortCurrencyPipe,
    ProjectsSearchComponent,
    StatusTagComponent,
    PriorityTagComponent,
    RequisitionTableComponent,
    StructureTreelistComponent,
    RequisitionPieChartComponent,
    LotsTagBoxComponent,
    ResourcesTagBoxComponent,
    LoadPanelComponent,
    DashboardRequisitionTableComponent,
    HighlighterPipe,
    DashboardEstimationTableComponent,
    InfoDashboardCardComponent,
    EstimationTableComponent,
    AlertMessageComponent,
    EstimationPieChartComponent,
    SearchProviderModalComponent,
    CreateProviderModalComponent,
    CreateEstimationDrawerComponent,
    ResourcesTreeSelectorComponent,
  ],
  exports: [
    CommonModule,
    NgZorroAntDModule,
    DevExtremeModule,
    ShortCurrencyPipe,
    ProjectsSearchComponent,
    StatusTagComponent,
    PriorityTagComponent,
    RequisitionTableComponent,
    StructureTreelistComponent,
    RequisitionPieChartComponent,
    LotsTagBoxComponent,
    ResourcesTagBoxComponent,
    LoadPanelComponent,
    DashboardRequisitionTableComponent,
    HighlighterPipe,
    DashboardEstimationTableComponent,
    InfoDashboardCardComponent,
    EstimationTableComponent,
    AlertMessageComponent,
    EstimationPieChartComponent,
    SearchProviderModalComponent,
    CreateProviderModalComponent,
    CreateEstimationDrawerComponent,
    ResourcesTreeSelectorComponent,
  ],
  providers: [CurrencyPipe],
})
export class SharedModule {}
